define(
  'SuiteCommerce.OrderStatus.Instrumentation.Collection',
  [
    'SuiteCommerce.OrderStatus.Instrumentation.Model',
    'underscore',
    'Backbone'
  ],
  function define(
    model,
    _,
    Backbone
  ) {
    'use strict';

    return Backbone.Collection.extend({
      model: model
    });
  }
);
